
export const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function makeCompleteUrlFromLastPart(urlLastPart) {
  let baseUrl = process.env.REACT_APP_API_URL;

  if(baseUrl[baseUrl.length] === "/") {
    baseUrl.pop();
  }

  let completeUrl = baseUrl;

  if(urlLastPart[0] !== "/") {
    completeUrl += "/";
  }

  completeUrl += urlLastPart;

  return completeUrl;
}

export async function postJsonRequest(_url, _body) {
  const jsonResponse = await fetch(
    _url,
    {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(_body),
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
  .then(handleErrors)
  .then(function (response) {
    return response.json();
  })
  .then(function (body) {
    return body;
  });

  return jsonResponse;
}

export async function getRequest(_url) {
  let rawReponse = await fetch(
    _url,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  );
  
  if (!rawReponse.ok) {
    throw new Error(rawReponse.statusText);
  }
  
  let jsonResponse = await rawReponse.json();

  return jsonResponse;
}


// WEBPACK FOOTER //
// ./src/utils/requestHelper.js